document.addEventListener("DOMContentLoaded", function() {
    //get all groups with products
    const gtmGroups = document.querySelectorAll("[data-product-group-gtm=\"product-group-gtm\"], [data-product-group-gtm=\"product-group-gtm-cart\"]");
    gtmGroups.forEach(el => {
        let productData = [];

        //observe - products after the page load
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Fetch the products again when new nodes are added
                    let products = el.querySelectorAll(".each-product-gtm");
                    if (products) {
                        setupProductEventListeners(products);
                    }
                }
            });
        });

        //config observer
        const config = { childList: true, subtree: true };
        observer.observe(el, config);

        //get products in page load
        let products = el.querySelectorAll(".each-product-gtm");
        if (products) {
            setupProductEventListeners(products);
        }

        function setupProductEventListeners(products) {
            products.forEach((product, index) => {
                function handleProductClick(el) {
                    el.addEventListener("click", function () {
                        let closestProduct = el.closest(".each-product-gtm");

                        //get necessary dynamic data
                        let itemListId = closestProduct.querySelector(".gtm-item-list-id").value;
                        let itemListName = closestProduct.querySelector(".gtm-item-list-name").value;
                        let itemAffiliation = closestProduct.querySelector(".gtm-affiliation").value;
                        let currency = closestProduct.querySelector(".gtm-currency").value;
                        let itemId = closestProduct.querySelector(".gtm-item_id").value;
                        let itemName = closestProduct.querySelector(".gtm-item_name").value;
                        let itemBrand = closestProduct.querySelector(".gtm-item_brand").value;

                        let itemCategory1 = closestProduct.querySelector(".gtm-item_category1")?.value;
                        let itemCategory2 = closestProduct.querySelector(".gtm-item_category2")?.value;
                        let itemCategory3 = closestProduct.querySelector(".gtm-item_category3")?.value;
                        let itemCategory4 = closestProduct.querySelector(".gtm-item_category4")?.value;
                        let itemCategory5 = closestProduct.querySelector(".gtm-item_category5")?.value;

                        let itemVariant = closestProduct.querySelector(".gtm-variant")?.value;

                        //get static data
                        let indexProduct = index + 1;
                        let quantityProduct = 1;

                        //get price & discount
                        let fullPrice = 0;
                        let discount = 0;
                        let pricePrd = closestProduct.querySelector(".gtm-price").value;
                        let comparePricePrd = closestProduct.querySelector(".gtm-discount").value;

                        let price = pricePrd / 100;
                        let salePrice = comparePricePrd / 100;

                        if (salePrice > price) {
                            fullPrice = price;
                            discount = parseFloat((salePrice - price).toFixed(2));
                        } else if (price) {
                            fullPrice = price;
                        }

                        const productDataObject = {
                            'item_id': itemId,
                            'item_name': itemName,
                            'affiliation': itemAffiliation,
                            'discount': discount,
                            'index': indexProduct,
                            'item_brand': itemBrand,
                            'item_list_id': itemListId,
                            'item_list_name': itemListName,
                            'price': fullPrice,
                            'currency': currency,
                            'quantity': quantityProduct,
                        };

                        //if categories exist, add in productData
                        const categories = [itemCategory1, itemCategory2, itemCategory3, itemCategory4, itemCategory5];
                        const uniqueCategories = [...new Set(categories.filter(Boolean))];

                        uniqueCategories.forEach((category, index) => {
                            const key = index === 0 ? "item_category" : `item_category${index + 1}`
                            productDataObject[key] = category;
                        });

                        //if variant exist, add in productData
                        if (itemVariant && itemVariant !== 'Default Title') {
                            productDataObject.item_variant = itemVariant;
                        }

                        //push on productData
                        productData.push(productDataObject);

                        //clear dataLayer
                        window.dataLayer =  window.dataLayer || [];

                        window.dataLayer.push({
                            event: "select_item",
                            ecommerce: {
                                'item_list_id': itemListId,
                                'item_list_name': itemListName,
                                'items': productData,
                            }
                        });
                    });
                }

                let cardLinkGtm1 = product.querySelectorAll(".gtm-href-link-product a");
                cardLinkGtm1.forEach((el) => {
                    if (el) handleProductClick(el);
                })  
                
                let cardLinkGtm2 = product.querySelectorAll(".line-item__info .gtm-href-link-product");
                cardLinkGtm2.forEach((el) => {
                    if (el){
                        handleProductClick(el);
                    }
                })

            });
        }
    });
});